import { FunctionComponent, PropsWithChildren, useMemo } from "react";

import { SubmissionFormMetaContext } from "@ui-components/form/submission-form/context/SubmissionFormMetaContext.tsx";
import { ISubmissionFormMetaContext } from "@ui-components/form/submission-form/context/SubmissionFormMetaContext.types.ts";

interface SubmissionFormMetaProviderProps
  extends PropsWithChildren<ISubmissionFormMetaContext> {}

export const SubmissionFormMetaProvider: FunctionComponent<
  SubmissionFormMetaProviderProps
> = ({ children, disabled, readonly }) => {
  const meta = useMemo(() => ({ disabled, readonly }), [disabled, readonly]);

  return (
    <SubmissionFormMetaContext.Provider value={meta} children={children} />
  );
};
